import { GROUPS_ADD_GROUP } from '../actions';
import { addGroup as addGroupApi } from '../api';
import fetchGroupSetApi from '../api/fetchGroupSet.api';
import refreshAccessToken from '../../actions/accessToken/refreshAccessToken.action';
import { currentClassRoomId as getCurrentClassRoomId } from '../../selectors/classroom';
import showToast from '../../toasts/operations/showToast.operation';
import { ADD_GROUP_SUCCESS, ADD_GROUP_ERROR } from './toasts';

const addGroupSuccess = ({ group, studentsWithNoGroup }) => ({
  type: GROUPS_ADD_GROUP,
  status: 'success',
  payload: { group, studentsWithNoGroup },
});

const addGroupError = ({ group, error }) => ({
  type: GROUPS_ADD_GROUP,
  status: 'error',
  payload: { group, error },
});

const addGroup = (group) => async (dispatch, getState) => {
  try {
    const state = getState();
    const spaceId = getCurrentClassRoomId(state);
    const accessToken = await refreshAccessToken(
      dispatch,
      getState
    )({ spaceId });
    const { group: createdGroup, studentsWithNoGroup } = await addGroupApi(
      accessToken,
      group
    );

    dispatch(
      addGroupSuccess({
        group: {
          ...createdGroup,
          students: createdGroup?.students || 0,
          educators: createdGroup?.educators || 0,
        },
        studentsWithNoGroup,
      })
    );
    dispatch(showToast(ADD_GROUP_SUCCESS));

    if (createdGroup?.hasConversation && !createdGroup?.conversationId) {
      // eslint-disable-next-line prefer-destructuring
      const set = createdGroup.set;
      const groupId = createdGroup.id;
      const poll = async (retries = 8, delay = 600) => {
        if (retries === 0) return;
        await new Promise((resolve) => setTimeout(resolve, delay));
        try {
          const updatedSet = await fetchGroupSetApi(accessToken, {
            groupSetId: set,
          });
          const updatedGroup = updatedSet?.groups?.find(
            (g) => g.id === groupId
          );
          if (updatedGroup?.conversationId) {
            dispatch({
              type: 'GROUPS_EDIT_GROUP',
              status: 'success',
              payload: {
                group: {
                  id: groupId,
                  set,
                  conversationId: updatedGroup.conversationId,
                },
                studentsWithNoGroup:
                  getState().groups?.sets?.[set]?.studentsWithNoGroup,
              },
            });
          } else {
            await poll(retries - 1, delay);
          }
        } catch {
          // silently ignore
        }
      };
      poll();
    }
  } catch (error) {
    dispatch(showToast(ADD_GROUP_ERROR));
    dispatch(addGroupError({ group, error }));
  }
};

export default addGroup;
